import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export var InputRender = function (_a) {
    var container = _a.container, content = _a.content;
    if (Array.isArray(content)) {
        return _jsx(_Fragment, { children: content.map(function (item, key) { return _jsx(InputRender, { container: container, content: item }, key); }) });
    }
    else if (content) {
        if (container) {
            var Cont = container;
            return _jsx(_Fragment, { children: _jsx(Cont, { children: content }) });
        }
        else {
            return _jsx(_Fragment, { children: _jsx("div", { children: content }) });
        }
    }
    return null;
};
